<template>
  <div id="maps">
    <div id="servermaps" style="width:100%;height:200px" />
  </div>
</template>
<script>
import AMap from 'AMap'
AMap && AMap.plugin(['AMap.Scale', 'AMap.DistrictSearch', 'AMap.PlaceSearch', 'AMap.Marker', 'AMap.IndoorMap', 'AMap.ToolBar', 'AMap.OverView', 'AMap.Geocoder', 'AMap.MapType', 'AMap.MouseTool', 'AMap.Polyline'], function () {
})
export default {
  props: {
    viewbasdatas: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      map: null,
      marker: null,
      infoWindow: null,
      imgurl: ''
    }
  },
  watch: {
    viewbasdatas (newdata) {
      if (newdata) {
        this.init()
      }
    }
  },
  created () {
  },
  mounted () {
    this.init()
  },
  methods: {

    init () {
      this.map = new AMap.Map('servermaps', {
        mapStyle: 'amap://styles/whitesmoke',
        resizeEnable: true,
        zoom: 16
      })
      console.log(this.viewbasdatas)
      var __this = this

      var geocoder = new AMap.Geocoder({
        city: '上海'
      })
      geocoder.getLocation(__this.viewbasdatas.address, function (status, result) {
        var startIcon = new AMap.Icon({
          // 图标尺寸
          // size: new AMap.Size(25, 34),
          // 图标的取图地址
          // image: '../../assets/images/xfz.png',
          // 图标所用图片大小
          // imageSize: new AMap.Size(60, 60),
          // 图标取图偏移量
          // imageOffset: new AMap.Pixel(-5, -5),
          title: '上海'
        })
        if (__this.viewbasdatas.latitude && __this.viewbasdatas.longitude) {
          const lat = __this.viewbasdatas.latitude
          const lng = __this.viewbasdatas.longitude
          __this.map.setCenter([lng, lat])
          __this.marker = new AMap.Marker({
            position: [lng, lat],
            map: __this.map
          })
          const content = [
            '<div style="position:relative; width:220px;height:80px; background:#fff;z-index:-10;padding:0 20px;font-family:test; border:1px solid #ea9639"><img src="/static/xfz.png" style="width:45px;position: absolute;bottom: -58%;left: 35%;"><p style="color:#0A2549; font-weight:700">' + (__this.viewbasdatas.name || '暂无数据') + ' </p><p style="color:#0A2549;">' + (__this.viewbasdatas.address || '暂无数据') + ' </p></div>'
          ]
          __this.infoWindow = new AMap.InfoWindow({
            isCustom: true, // 使用自定义窗体
            content: content.join('<br/>'),
            offset: new AMap.Pixel(16, -45)
          })
          // __this.marker.setMap(__this.map)

          __this.infoWindow.open(__this.map, __this.marker.getPosition())
          // __this.map.add(__this.marker);
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/basicComponents/awapsmall.vue